import { neonAuthClient } from '../lib/neonAuthClient';

export const laseaAuthService = {
  /**
   * Sign in LaSea user (admin or customer)
   * The worker returns user.role directly, so no extra DB call needed.
   */
  async signIn(email, password) {
    try {
      const { data, error } = await neonAuthClient.signInWithPassword({ email, password });

      if (error) {
        throw new Error(error.message || 'Login failed. Please check your credentials.');
      }

      if (!data?.user) {
        throw new Error('Not a valid LaSea user account');
      }

      // Role is returned directly from the Worker's login response
      return { user: data.user, role: data.user.role };
    } catch (err) {
      console.error('Sign in error:', err);
      throw err;
    }
  },

  /**
   * Sign up new LaSea customer via Worker
   */
  async signUpCustomer(email, password, fullName, companyName, phone) {
    const { data, error } = await neonAuthClient.signUp({
      email,
      password,
      options: {
        data: {
          full_name: fullName,
          role: 'customer',
        }
      }
    });

    if (error) throw error;
    return data;
  },

  /**
   * Sign out current user
   */
  async signOut() {
    try {
      await neonAuthClient.signOut();
    } catch (err) {
      console.warn('Sign out error:', err);
    }
  },

  /**
   * Get current session
   */
  async getSession() {
    const { data: { session }, error } = await neonAuthClient.getSession();
    if (error) throw error;
    return session;
  },

  /**
   * Password reset - not yet implemented
   */
  async resetPassword(email) {
    throw new Error('Password reset not yet implemented. Please contact your administrator.');
  },

  /**
   * Security question verification - not yet implemented
   */
  async verifySecurityAnswer(email, answer) {
    throw new Error('Security questions not yet implemented.');
  },

  /**
   * Get security question - not yet implemented
   */
  async getSecurityQuestion(email) {
    throw new Error('Security questions not yet implemented.');
  },

  /**
   * Update password - not yet implemented
   */
  async updatePassword(newPassword) {
    throw new Error('Password update not yet implemented.');
  }
};